import React, { useState } from "react";
import "../../Assets/scss/pages/security.scss";
import DashboardPagesTemplate from "../../Template/DashboardPagesTemplate";
import DashboardPageTitle from "../../Components/InnerPageTitle";
import { useTranslation } from "react-i18next";
import TwoFactorStatus from "../../Components/GoogleAuthenticator/TwoFactorStatus";
import UpdatePassword from "../../Components/Profile/UpdatePassword";
import IPAddressSection from "../../Components/TrustedIPManager/IPAddressSection";

const SecurityPage: React.FC = () => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState<string>(t("Two-factor authentication"));
  const tabList = [
    t("Two-factor authentication"),
    t("IP Address"),
    t("Change Password"),
  ];

  const renderContent = () => {
    switch (activeTab) {
      case t("Two-factor authentication"):
        return (
          <>
            <TwoFactorStatus />
          </>
        );
        case t("IP Address"):
        return (
          <>
            <IPAddressSection userId={""} />
          </>
        );
      case t("Change Password"):
        return (
          <div className="aioa-dashboard-profile-content">
            <UpdatePassword />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <DashboardPagesTemplate>
      <DashboardPageTitle
        pageTitle={`${t("security")}`}
        subPageTitle={`${t("Update your security information")}`}
      />
      <div className="security-tabs">
        <ul className="tab-header">
          {tabList.map((tab) => (
            <li
              key={tab}
              className={tab === activeTab ? "active" : ""}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </li>
          ))}
        </ul>
        <div className="tab-body">{renderContent()}</div>
      </div>
    </DashboardPagesTemplate>
  );
};

export default SecurityPage;

